

import state from './modulePPOBState.js'
import mutations from './modulePPOBMutations.js'
import actions from './modulePPOBActions.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
